import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { getHomeData } from "../data/home.js";
import "../pages/homePage/homePage.css";

const ServicesSection = () => {
  const homeData = getHomeData();
  const services = homeData.services;

  return (
    <section className="py-5 bg-light">
      <Container fluid className="col-md-11 mx-auto px-3 overflow-hidden">
        <Row className="g-4">
          {services.map((service, index) => (
            <Col
              lg={4}
              md={6}
              key={index}
              className="overflow-hidden"
              data-aos="fade-left"
              data-aos-delay={index * 80}
            >
              <Card className="service-card text-white border-0">
                <Card.Img src={service.image} className="service-img service-img-animate" />
                <Card.ImgOverlay className="d-flex flex-column justify-content-end">
                  <Card.Title className="fw-bold service-text-animate">
                    {service.title}
                  </Card.Title>
                  <Card.Text className="small service-text-animate">
                    {service.desc}
                  </Card.Text>
                </Card.ImgOverlay>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ServicesSection;


